import { render, staticRenderFns } from "./fileOversizeDialog.vue?vue&type=template&id=70c4f57b"
import script from "./fileOversizeDialog.vue?vue&type=script&lang=js"
export * from "./fileOversizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@0.28.11_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6_webpack-cli@4.10.0_/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports